export const condorCustomerServiceEmail = "condormonitorinfo@gmail.com";